import * as Yup from 'yup';

export const local = Yup.object().shape({
  network: Yup.string().required('shop.airtime.form.error.network'),
  amount: Yup.string().required('shop.airtime.form.error.amount'),
  phone: Yup.string()
    .matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, {
      message: 'shop.airtime.form.error.phone'
    })
    .required('shop.airtime.form.error.phone')
});

export const international = Yup.object().shape({
  country: Yup.string().required('shop.airtime.form.error.country'),
  package_id: Yup.string().required('shop.airtime.form.error.network'),
  amount: Yup.string().required('shop.airtime.form.error.amount'),
  phone: Yup.string()
    .matches(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/, {
      message: 'shop.airtime.form.error.phone'
    })
    .required('shop.airtime.form.error.phone')
});
